import { useState } from "react";
import "../../styles/SampleImage.css";

export default function SampleImage({ sampleImages = [] }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!sampleImages || sampleImages.length === 0) {
    return null;
  }

  const currentImage = sampleImages[currentImageIndex];
  const imageUrl = currentImage?.preview || currentImage?.url;

  const handlePrevious = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? sampleImages.length - 1 : prev - 1,
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) =>
      prev === sampleImages.length - 1 ? 0 : prev + 1,
    );
  };

  return (
    <div className='sample-image-container'>
      {typeof imageUrl === "string" ? (
        <>
          <div className='sample-image-wrapper'>
            <img
              src={imageUrl}
              alt={`Sample ${currentImageIndex + 1}`}
              className='sample-image-display'
            />
          </div>
          {sampleImages.length > 1 && (
            <>
              <div className='image-gallery-controls'>
                <button
                  className='btn btn-sm btn-outline-primary'
                  onClick={handlePrevious}
                  title='Previous image'
                >
                  <i className='bi bi-chevron-left'></i>
                </button>
                <span className='image-counter'>
                  {currentImageIndex + 1} / {sampleImages.length}
                </span>
                <button
                  className='btn btn-sm btn-outline-primary'
                  onClick={handleNext}
                  title='Next image'
                >
                  <i className='bi bi-chevron-right'></i>
                </button>
              </div>
              <div className='image-thumbnails'>
                {sampleImages.map((img, idx) => (
                  <div
                    key={idx}
                    className={`thumbnail ${
                      idx === currentImageIndex ? "active" : ""
                    }`}
                    onClick={() => setCurrentImageIndex(idx)}
                  >
                    <img
                      src={img.preview || img.url}
                      alt={`Thumbnail ${idx + 1}`}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      ) : (
        <div className='alert alert-info' role='alert'>
          <i className='bi bi-info-circle pe-2'></i>
          Image data not available
        </div>
      )}
    </div>
  );
}
